export default "__VITE_ASSET__dce67225__"